module.exports = __webpack_public_path__ + "static/media/toolbar-search.5f94fd80.svg";